import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { openClose } from '@core/animations/animations';
import { BusinessUser, BusinessUserRole } from '@models/businesses';
import { SelectSnapshot } from '@ngxs-labs/select-snapshot';
import { Select } from '@ngxs/store';
import { BusinessUsersState } from '@state/business-users/business-users.state';
import LogRocket from 'logrocket';
import { Observable } from 'rxjs';
import { ICON } from '@core/util/icon';
import { NgForm } from '@angular/forms';
import { TitlePlusService } from '@services/title-plus/title-plus.service';

interface LawyerLsnMapping {
	name: string;
	id: string;
	lsn: string;
}

export interface TitlePlusLsnComponentData {
	userId?: string;
}

@Component({
	selector: 'app-title-plus-lsn',
	templateUrl: './title-plus-lsn.component.html',
	styleUrls: ['./title-plus-lsn.component.scss'],
	animations: [openClose()],
	standalone: false,
})
export class TitlePlusLsnComponent implements OnInit {
	public loading = true;
	public loadingError = false;
	public saving = false;
	public savingError = false;
	public mappedLawyers: LawyerLsnMapping[] = [];
	public ICON = ICON;
	public businessUserRole = BusinessUserRole;
	public userId: string;
	public selectedLawyer: BusinessUser;

	@SelectSnapshot(BusinessUsersState.getLawyersIfAdmin) lawyers: BusinessUser[];
	@Select(BusinessUsersState.getLoggedInUserRole)
	userRole$: Observable<BusinessUserRole>;

	constructor(
		private titlePlusService: TitlePlusService,
		private matDialogRef: MatDialogRef<TitlePlusLsnComponent>,
		@Inject(MAT_DIALOG_DATA) public _data: TitlePlusLsnComponentData,
	) {
		this.userId = _data.userId;
	}

	ngOnInit(): void {
		this.matDialogRef.addPanelClass('title-plus-lsn-modal');
		this.loadMappings();
	}

	close() {
		this.matDialogRef.close();
	}

	loadMappings() {
		try {
			this.loading = true;

			if (this.userId) {
				this.selectedLawyer = this.lawyers.find(
					(lawyer) => lawyer.id === this.userId,
				);
			}

			let mappedLawyers: LawyerLsnMapping[] = [];

			if (this.selectedLawyer) {
				mappedLawyers = [
					{
						name: `${this.selectedLawyer.firstName} ${this.selectedLawyer.lastName}`,
						id: this.selectedLawyer.id,
						lsn: this.selectedLawyer.lsn ?? null,
					},
				];
			} else {
				mappedLawyers = this.lawyers.map((lawyer) => {
					const mapping: LawyerLsnMapping = {
						name: `${lawyer.firstName} ${lawyer.lastName}`,
						id: lawyer.id,
						lsn: lawyer.lsn ?? null,
					};

					return mapping;
				});
			}

			this.mappedLawyers = mappedLawyers;
		} catch (err) {
			this.loadingError = true;
			LogRocket.log('TitlePLUS - Unable to get load mappings', err);
		} finally {
			this.loading = false;
		}
	}

	async save(form: NgForm) {
		if (!form.valid) {
			return;
		}

		this.saving = true;

		try {
			const mappings: { userId: string; lsn: string }[] =
				this.mappedLawyers.map((x) => ({
					userId: x.id,
					lsn: x.lsn || '',
				}));

			const SetLSNReq = {
				mapping: mappings,
			};

			this.titlePlusService.setLsn(SetLSNReq);

			const changedLawyers = this.mappedLawyers
				.filter((mapping) => {
					const user = this.lawyers.find((lawyer) => lawyer.id === mapping.id);
					console.log('user.lsn', user.lsn);
					console.log('mapping.lsn', mapping.lsn);
					return user.lsn !== mapping.lsn;
				})
				.map((mapping) => mapping.id);

			this.titlePlusService.disconnectLawyers({ lawyerIds: changedLawyers });

			this.close();
		} catch (err) {
			this.savingError = true;
			LogRocket.log('Error saving lsn profile mappings', err);
		} finally {
			this.saving = false;
		}
	}
}
